import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isSound: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const onClick = () => emits('click', !props.isSound);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onClick: onClick
            }, [
                _createVNode(MaterialIcon, {
                    class: "middle",
                    name: props.isSound ? 'volume_up' : 'volume_off'
                }, null, 8, ["name"])
            ]));
        };
    }
});
